import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import router from '@/router';
import MixpanelPlugin from '@/plugins/mixpanel';
import { default as en } from '@/i18n/en.json';
import { default as enIn } from '@/i18n/en_IN.json';
import { default as nl } from '@/i18n/nl.json';
import { default as de } from '@/i18n/de.json';
import { default as fr } from '@/i18n/fr.json';
import { default as es } from '@/i18n/es.json';
import { default as it } from '@/i18n/it.json';

const lang = document.documentElement.getAttribute('lang') ?? navigator.language.split('-')[0] ?? 'en';
const widget = document.getElementById('shop-component')?.getAttribute('widget');

async function getRootComponent() {
  const env = process.env.NODE_ENV;
  switch (true) {
    case env === 'development':
      return (await import('./App.vue')).default;
    case widget === 'rate-finder':
      return (await import('./RateFinder.vue')).default;
    default:
      return (await import('./Shop.vue')).default;
  }
}

const translations = {
  locale: lang,
  messages: {
    en,
    'en-in': enIn,
    nl,
    de,
    fr,
    es,
    it,
  },
  fallbackLocale: 'en',
  globalInjection: true,
  legacy: false,
};

const i18n = createI18n(translations);

getRootComponent().then((App) => {
  const app = createApp(App).use(i18n).use(MixpanelPlugin);
  const env = process.env.NODE_ENV;
  if (env === 'development') {
    app.use(router);
  }
  app.mount('#shop-component');
});

type Locales = 'fr' | 'de' | 'it' | 'nl' | 'es' | 'en' | 'en-in';
i18n.global.locale = Object.keys(translations.messages).includes(lang) ? (lang as Locales) : 'en';
